import { motion } from "framer-motion";

const TONES = { blue: "text-primary", orange: "text-orange-600", cyan: "text-cyan-600", emerald: "text-emerald-600" };

export default function PageHeader({ eyebrow, title, subtitle, actions, tone = "blue", testId }) {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-wrap items-end justify-between gap-4" data-testid={testId}>
      <div className="min-w-0">
        {eyebrow && <div className={`text-[11px] font-mono-label font-semibold uppercase tracking-[0.28em] mb-1.5 ${TONES[tone] || TONES.blue}`}>{eyebrow}</div>}
        <h1 className="font-display text-2xl sm:text-3xl lg:text-[34px] font-extrabold tracking-tight leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </motion.div>
  );
}
